<div class="klab-alert" [ngClass]="'klab-alert--' + variant">
  <div class="klab-alert__icon" *ngIf="iconSrc">
    <img [src]="iconSrc" [alt]="iconAlt" />
  </div>

  <div class="klab-alert__content">
    <div *ngIf="title" class="klab-alert__title">
      {{ title }}
    </div>

    <div *ngIf="message" class="klab-alert__text">
      {{ message }}
    </div>
  </div>
</div>
